module.exports = {"id":"s1-q2","text":"Does your job require you to use a computer to perform most of your duties?","multiselect":false,"options":[{"id":"s1-q2-a1","text":"Yes","next":"s1-q2a","capability":2,"access":1,"focusAreaBaseline":5},{"id":"s1-q2-a2","text":"No","next":"s1-q3","capability":-2,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s1-q2.json
// module id = 888
// module chunks = 41